import { Component, inject, OnDestroy } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { CarriagesService } from '../../../services/carriages.service';

@Component({
    selector: 'app-download-carriages',
    templateUrl: './download-carriages.component.html',
    styleUrls: ['./download-carriages.component.scss'],
})
export class DownloadCarriagesComponent implements OnDestroy {

    public modal = inject(DynamicDialogRef);
    private service = inject(CarriagesService);

    public error: boolean;
    public isBusy: boolean;
    public startedDownload = false;
    private destroy$ = new Subject<void>();

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete()
    }

    startDownload() {
        this.isBusy = true;
        this.error = false;
        this.service
            .startCarriagesDownload()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.isBusy = false;
                    this.startedDownload = true;
                },
                error: () => {
                    this.isBusy = false;
                    this.error = true;
                }
            });
    }
}
